<style lang="scss">
    @import "@/assets/scss/vuexy/pages/Config.scss";
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4 edit-information-view">
        <div class="vx-col w-full">
          <vs-button :to="`/energy/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
        </div>
        <div class="vx-col w-full">
            <vx-card class="grid-view-item mb-base overflow-hidden">
                <h4>
                    {{$t("Labels.DeviceInformation")}}
                </h4>
                <form class="edit-form">
                    <div class="item-grid-view vx-row match-height mt-4">
                        <div class="lg:w-1/2 sm:w-1/2 w-full px-4">
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.DeviceName')" type="text" v-model="response.alias"/>
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.References')" type="text" v-model="response.location_string"/>
                            <div class="text-center text-3xl mt-3">{{$t("Labels.ReportTime")}}</div>
                            <vs-divider/>
                            <timeConfig v-if="response.time !== undefined" v-on:time="onTimeChange" v-on:unity="onUnityChange" :time="response.time !== ''? parseInt(response.time): 0" :unity="response.time_unity"/>
                            <div class="submit-button-container">
                              <vs-button @click="formSubmit" class="submit-button">
                                  {{$t("Labels.Save")}}
                              </vs-button>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full px-4">
                            <div class="map-container">
                                <l-map :center="center" :zoom="zoom" v-if="response">
                                    <l-tile-layer :attribution="attribution" :url="url">
                                    </l-tile-layer>
                                    <l-marker :draggable="draggable" :lat-lng="marker" ref="position_marker">
                                       <l-icon :icon-anchor="[12, 27]" >
                                          <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                      </l-icon>
                                    </l-marker>
                                </l-map>
                            </div>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import timeConfig from '@/components/timeConfig/timeConfig.vue'
import { request } from '@/request.js'
/* global L:true */

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    timeConfig
  },
  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      draggable: true,
      response: [],
      time: 0,
      time_unity: '',
      uuid: this.$route.params.uuid
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/energies/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        const [lat, long] = this.response.location.split(',')
        this.marker = L.latLng(lat, long)
        this.center = L.latLng(lat, long)
        this.status_mapa = true
      })
    },

    async formSubmit (e) {
      e.preventDefault()
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/energies/${this.uuid}`,
        method: 'PUT',
        params: {
          time: this.response.time,
          time_unity: this.response.time_unity,
          location: `${location.lat},${location.lng}`,
          alias: this.response.alias,
          location_string: this.response.location_string
        }
      }
      await request(params)
    },
    onTimeChange (value) {
      this.response.time = value
    },
    onUnityChange (value) {
      this.response.time_unity = value
    }
  },

  created () {
    this.getResponse()
  }
}
</script>
